import './zoom-info-control.styl'

class ZoomInfoControl {
  onAdd(map) {
    this._map = map;
    this._container = document.createElement('div');
    this._container.className = 'maplibregl-ctrl maplibregl-ctrl-zoominfo';

    this._container.innerHTML = `Zoom: ${this._map.getZoom().toFixed(2)}`;

    this._map.on('zoom', () => {
      const zoom = `Zoom: ${this._map.getZoom().toFixed(2)}`;
      this._container.innerHTML = zoom;
    });

    return this._container;
  }

  onRemove() {
    this._container.remove();
    this._map = undefined;
  }
}

export default ZoomInfoControl;
